import { IRetentionBookingItem } from '@dashboardWirelineRetentionDepartment/RetentionManagerDepartment.models';

import {
  GET_RETENTION_BOOKING_DATA_REQUEST,
  GET_RETENTION_BOOKING_DATA_SUCCESS,
  GET_RETENTION_BOOKING_DATA_FAILURE,
} from './actionsTypes';

interface IGetRetentionBookingDataState {
  isLoading: boolean;
  count: number;
  results: IRetentionBookingItem[];
  error: object;
}

const initialState: IGetRetentionBookingDataState = {
  isLoading: false,
  count: 0,
  results: [],
  error: {},
};

const getRetentionBookingDataReducer = (state = initialState, {
  type, data, error,
}) => {
  if (type === GET_RETENTION_BOOKING_DATA_REQUEST) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (type === GET_RETENTION_BOOKING_DATA_SUCCESS) {
    return {
      ...state,
      ...data,
      isLoading: false,
    };
  }

  if (type === GET_RETENTION_BOOKING_DATA_FAILURE) {
    return {
      ...state,
      isLoading: false,
      results: [],
      count: 0,
      error,
    };
  }

  return state;
};
export default getRetentionBookingDataReducer;
